import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";

import {
  createSearchParams,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { Button } from "@covertree/ui/buttons/Button";
import DisplayPropertiesTableWithBackground from "@covertree/ui/content/DisplayPropertiesTableWithBackground";
import { Modal } from "@covertree/ui";

import {
  BASE_COVERAGE_DATA_PATH,
  COVERAGE_DATA_ROUTES,
} from "@routing/Residents/ProofOfCoverage/CoverageData";
import { moveBackInPathname } from "@utils";

interface Props {
  residentSiteAddress: string;
  policyUnitAddress: string;
  open: boolean;
  onClose: () => void;
}
export default function AddressMismatch({
  residentSiteAddress,
  policyUnitAddress,
  open,
  onClose,
}: Props) {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const handleContinue = () => {
    navigate(
      {
        pathname: `${moveBackInPathname(location.pathname, 1)}/${BASE_COVERAGE_DATA_PATH}/${COVERAGE_DATA_ROUTES.COVERAGE_DETAILS}`,
        search: createSearchParams(searchParams).toString(),
      },
      { relative: "path" }
    );
  };

  return (
    <Modal open={open} onClose={onClose} maxWidth="md" hideCloseButtonAndTitle>
      <Grid
        container
        display="flex"
        direction="column"
        gap={4}
        alignItems="flex-start"
        justifyContent="space-around">
        <Grid item xs={12}>
          <Typography fontSize={32}>Address Mismatch</Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography fontSize={20}>
            Unit address on the policy does not match the resident site address.
            Do you want to ignore it and continue?
          </Typography>
        </Grid>
        <Grid item xs={12} width={"100%"}>
          <DisplayPropertiesTableWithBackground
            properties={[
              {
                label: "Policy Unit Address",
                value: policyUnitAddress,
              },
              {
                label: "Resident Site Address",
                value: residentSiteAddress,
              },
            ]}
          />
        </Grid>
        <Stack direction="row" gap={1}>
          <Button onClick={handleContinue}>Ignore and continue</Button>
          <Button variant="outlined" onClick={onClose}>
            Cancel
          </Button>
        </Stack>
      </Grid>
    </Modal>
  );
}
